__turbopack_context__.v({
  "contact": "m8sw2q_contact",
  "container": "m8sw2q_container",
  "content": "m8sw2q_content",
  "image": "m8sw2q_image",
  "innerImage": "m8sw2q_innerImage",
  "mobileTitle": "m8sw2q_mobileTitle",
  "text": "m8sw2q_text",
});
